import dayjs from 'dayjs';
import { ListingPricingType } from '@ha/api/v2/types/Listing';
import { RentalConditions } from '@ha/api/v2/types/RentalConditions';
import { IntlObject } from 'ha/i18n/types';
import { CurrencyFormat } from '@ha/intl';

const getInstalmentsPricing = (
  rentalConditions: RentalConditions | null,
  pricingType: ListingPricingType,
  formatDate: IntlObject['formatDate'],
  formatCurrency: IntlObject['formatCurrency'],
) => {
  let isCrossedPrice = false;

  const currencyFormat =
    rentalConditions?.currency === 'EUR'
      ? CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION_NO_GROUPING
      : CurrencyFormat.WITH_CURRENCY_CODE_NO_FRACTION_NO_GROUPING;

  const instalmentsPrices =
    rentalConditions &&
    rentalConditions.instalments.slice(0, 2).map(instalment => {
      const instalmentDate = dayjs(instalment.dueDate).add(1, 'month').format();

      const monthlyPriceItem =
        rentalConditions.pricingData?.monthlyPrices?.prices.find(
          (item: { month: string; price: number }) =>
            item.month.includes(`-${formatDate('MM', instalmentDate)}`),
        );
      const monthlyPrice = monthlyPriceItem?.price;
      let crossedPrice = '';
      if (pricingType === ListingPricingType.MONTHLY) {
        crossedPrice =
          monthlyPrice && monthlyPrice !== instalment.amount
            ? formatCurrency(
                monthlyPrice,
                rentalConditions.currency,
                currencyFormat,
              )
            : '';
      } else if (
        pricingType === ListingPricingType.FLAT &&
        rentalConditions.pricingData.flatPrice
      ) {
        crossedPrice =
          rentalConditions.pricingData.flatPrice !== instalment.amount
            ? formatCurrency(
                rentalConditions.pricingData.flatPrice,
                rentalConditions.currency,
                currencyFormat,
              )
            : '';
      }
      if (crossedPrice) isCrossedPrice = true;
      return {
        caption: formatDate('MMMM YYYY', instalmentDate),
        crossedPrice,
        value: formatCurrency(
          instalment.amount,
          rentalConditions.currency,
          currencyFormat,
        ),
      };
    });
  return {
    isCrossedPrice,
    instalmentsPrices,
  };
};
export { getInstalmentsPricing };
